import EventTracker from './tracking-events';

const tracker = new EventTracker({
  action: 'default_action',
});
export default tracker;
